import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

const savedLanguage = localStorage.getItem('appLanguage') || 'en'; // Default to 'en' if no language is saved

i18n
.use(LanguageDetector)
.use(initReactI18next).init({
  resources: {
    en: require('./locale/en.json'), // Import English translations
    zh_CN: require('./locale/zh_CN.json'), // Import Chinese translations
  },
  
  lng: savedLanguage, // Set default language
  fallbackLng: 'en', // Fallback language in case of missing translations
  interpolation: {
    escapeValue: false, // React already handles escaping
  }
});

//i18n.changeLanguage("zh_CN");

export default i18n;
